import React from "react";
import { Grid } from "@material-ui/core";

import Menu from "./Menu";
import useStyles from "./styles";

const Navbar = ({ apiData }) => {
  const { header } = useStyles();
  return (
    <header className={header}>
      <Grid container>
        <Grid item xs={12}>
          <Menu apiData={apiData} />
        </Grid>
      </Grid>
    </header>
  );
};

export default Navbar;
